var _style, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInviteLinkInactive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#B4C3D0;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M22.4,12.8L20,10.4c0,0,0.4,2.1-0.8,4l0.8,0.8l0,0c0.9,0.9,0.9,2.3,0,3.1l-1.6,1.6c-0.9,0.9-2.3,0.9-3.2,0 l-5.6-5.6c-0.9-0.9-0.9-2.4,0-3.2l1.6-1.6L8.8,7.2L7.2,8.8c-0.6,0.6-1,1.2-1.3,2c-0.8,2-0.4,4.4,1.3,6.1l5.6,5.6 c2.2,2.2,5.8,2.1,8,0l1.6-1.6C24.6,18.5,24.6,15,22.4,12.8z M18,13.3c0.8-2,0.4-4.4-1.2-6l-5.6-5.6c-2.2-2.2-5.8-2.2-8,0L1.7,3.2 c-2.2,2.2-2.2,5.8,0,8L4,13.6c0,0-0.4-2.1,0.8-4L4.1,8.8C3.2,8,3.2,6.5,4.1,5.6L5.6,4c0.9-0.9,2.3-0.8,3.2,0l5.5,5.5l0,0 c0.9,0.9,0.9,2.3,0,3.1l-1.6,1.6l0,0l2.4,2.4l0,0l1.6-1.6C17.4,14.6,17.8,14,18,13.3z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInviteLinkInactive);
export default __webpack_public_path__ + "static/media/invite_link_inactive.5c4d37f7306fbc3a4ecf355e376f27b6.svg";
export { ForwardRef as ReactComponent };